/** 支持的语言列表（新增语言：追加此项、注册 messages、复制 flags/{code}.svg） */
export const SUPPORTED_LOCALES = [
  { value: 'en-US', label: 'English', shortLabel: 'EN', flag: 'us' },
  { value: 'zh-CN', label: '中文', shortLabel: '中文', flag: 'cn' },
];

export const DEFAULT_LOCALE = 'en-US';
export const FALLBACK_LOCALE = 'zh-CN';
export const LOCALE_STORAGE_KEY = 'clawbridge-official-locale';

/** 按 locale value 取元数据 */
export function getLocaleMeta(value) {
  return SUPPORTED_LOCALES.find((item) => item.value === value);
}

/** 解析国旗 code，优先使用配置项 flag */
export function resolveFlag(localeItem) {
  if (!localeItem) return '';
  return localeItem.flag ?? localeItem.value.split('-').pop()?.toLowerCase() ?? '';
}
